import React, { useState } from "react";
import { Col } from "reactstrap";
import ContentImageModel from "../../components/modals/ContentImageModel";
import { QuestionHeading } from "../../components/question/question_heading";
import { exerciseType } from "../../components/constants/constants";
import QuestionDescription from "../../components/question/QuestionDescrption";
import { handleHeaderInput } from "../../components/edit_quiz_helper/EditQuizHelper";
export const ExerciseContent = ({
  data,
  studentid,
  studentAssessmentId,
  isReview,
  datatype,
  visualizerToggle,
  onUpdate,
}) => {
  const [expandData, setExpandData] = useState(false);
  const [Contentedit, setContentedit] = useState(false);
  const [ImageModal, setImageModal] = useState(false);
  const ImageToggle = () => setImageModal(!ImageModal);

  setTimeout(function () {
    if (isReview) {
      setExpandData(true);
    }
  }, 500);

  return (
    <Col className={data.task_type === exerciseType.WRITING_TASK ? "px-0" : ""}>
      <div
        class="d-flex flex-column quiz-bottom-border"
        style={{ minHeight: "10vh" }}
      >
        <QuestionHeading
          data={data}
          datatype={datatype}
          visualizerToggle={visualizerToggle}
          setContentedit={setContentedit}
          Contentedit={Contentedit}
          onUpdate={onUpdate}
        />
        {data.task_type === exerciseType.LISTENING_TASK ? (
          <div className="pt-3">
            <div>
              <div className="pb-3">
                {" "}
                <audio
                  src={data?.g_audio_url ? data?.g_audio_url : ""}
                  className={ data?.g_audio_url ? "audio-size" : "audio-size audio_loader"}
                  controls
                  controlsList="noplaybackrate nodownload"
                  
                >
                </audio>
                {" "}
              </div>
              <p className="quiz-bottom-border"></p>
            </div>
          </div>
        ) : null}
        {data.html_content?.content && data?.prompt_content?.isMounted && (
          <QuestionDescription
            description={
              <div
                className=""
                contentEditable={Contentedit}
                spellcheck="false"
                data-gramm="false"
                onInput={handleHeaderInput({
                  type: "htmlcontent",
                  quizdata: data,
                })}
                dangerouslySetInnerHTML={{
                  __html: ` ${data.html_content?.content} ${
                    !data?.html_content?.isMounted
                      ? `<span class="blinking-cursor"></span>`
                      : ""
                  }`,
                }}
              />
            }
            isReview={expandData}
            showBtn={true}
            data={data}
            ImageToggle={ImageToggle}
          />
        )}
      </div>
      <ContentImageModel
          data={data}
          isOpen={ImageModal}
          toggle={ImageToggle}
      />
    </Col>
  );
};
